export const rowDrillDetailsPath = '/rowDrillDetail/:periodName/:bookType/:reportLineType/:reportingCurrency/:groupType/:groupItem/:countryTaxType/';

export const BOOK_TYPES = {
  US_SUMMARY: 'US_SUMMARY',
  US_FED: 'US_FED',
  US_STATE: 'US_STATE',
  TED_NON_US_GAAP: 'TED_NON_US_GAAP',
  TED_NON_US_STAT: 'TED_NON_US_STAT',
} as const;

export const BOOK_TYPE_LETTERS_TO_LABELS = {
  P: 'GAAP',
  G: 'GAAP To STAT',
  A: 'STAT',
};

export const HISTORICAL_BOOK_TYPES = {
  US_FED: 'US_FED',
  US_STATE: 'US_STATE',
  TED_NON_US_GAAP: 'TED_NON_US_GAAP',
  TED_NON_US_STAT: 'TED_NON_US_STAT',
};

export const GROUP_TYPES = {
  BU: 'BU',
  BZ: 'BZ',
  CC: 'CC',
  CO: 'CO',
  LE: 'LE',
  GR: 'GR',
  CTT: 'CTT',
};

export const REPORT_LINE_TYPES = {
  CREDIT: 'CREDIT',
  DEF_CREDIT: 'DEF_CREDIT',
  PERM_DIFF: 'PERM_DIFF',
  TEMP_DIFF: 'TEMP_DIFF',
  G2S_NONREV_DIFF: 'G2S_NONREV_DIFF',
  G2S_REV_DIFF: 'G2S_REV_DIFF',
  STATE_CUR_TAX_ADJ: 'STATE_CUR_TAX_ADJ',
  STATE_PERM_DIFF: 'STATE_PERM_MODS',
  STATE_TEMP_DIFF: 'STATE_TEMP_MODS',
  STATE_CUR_TAX: 'STATE_CUR_TAX',
  CUR_TAX: 'CUR_TAX',
  CUR_TAX_EXP_TAX_CUR: 'CUR_TAX_EXP_TAX_CUR',
} as const;

export const REPORT_SORT_COLUMN = {
  BU: 'BUSINESS_UNIT',
  BZ: 'BUSINESS',
  CC: 'COMPANY_CODE',
  CO: 'COUNTRY_NAME',
  LE: 'LEGAL_ENTITY',
  GR: 'COMPANY_CODE',
};

export const SOURCE_CURRENCY = {
  SourceCurrency: 'Source Currency',
  TaxCurrency: 'Tax Currency',
  FunctionalCurrency: 'Functional Currency',
};
